module.exports = __webpack_public_path__ + "ddd3279a8263149bd5522e12d3c24668.pdf";